<template>
	<div
		class="checkbox-indicator"
		:class="classes"
	>
		<transition name="fade" mode="out-in">
			<font-awesome-icon key="check" :icon="['far', 'check']" class="check" fixed-width v-if="selected" />
			<font-awesome-icon key="square" :icon="['fas', 'square']" class="square" fixed-width v-else-if="partiallySelected" />
		</transition>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { CSSClasses } from '@/common/types';

library.add(faCheck, faSquare);

export declare type CheckboxSizes = 'sm' | 'md';

@Component
export default class CheckboxIndicator extends Vue {
	@Prop({ default: false, type: Boolean })
	selected: boolean;

	@Prop({ default: false, type: Boolean })
	partiallySelected: boolean;

	@Prop({ default: 'md' })
	size: CheckboxSizes;

	get classes(): CSSClasses {
		return {
			'selected': this.selected,
			'partially-selected': this.partiallySelected,
			[this.size]: true
		};
	}
}
</script>

<style lang="scss">
.checkbox-indicator {
	@apply rounded text-center border flex flex-row items-center justify-center;
	font-weight: 600;
	width: 22px;
	height: 22px;

	border: 1px solid rgba(var(--mainRGB), .15);
	box-shadow: rgba(var(--mainRGB), .05) 0 1px 2px;

	transition: background-color 100ms linear;

	&.sm {
		border-radius: 4px;

		width: 16px;
		height: 16px;

		font-size: 12px;
	}

	.check {
		@apply text-fill relative;
		top: 1px;
	}

	.square {
		@apply text-main relative;
		top: 0px;
	}

	&.selected {
		@apply text-fill bg-fill-accent border-accent-border;
	}
}
</style>
